import * as types from "./mutation-types";
import store from "@/store";
import {SET_CAS_INFO, SET_CURRENT_PAPER_INFO, SET_SYSTEM_INFO} from "./mutation-types";
const mutations = {
	[types.SET_USERINFO](state, userInfo) {
    const {logintype} = userInfo//cas登录的话里面有logintype，别的地方获取不到的只有登录后获取到，但是后期用户信息回更新，这个状态必须保存写回用户
    let userNow={...userInfo}
    if(logintype){
      userNow={...userNow,logintype}
    }
    // console.log('userNow')
    // console.log(userNow)
    // console.log('---------------------')
		// state.userInfo = userInfo;
		state.userInfo = userNow;
	},
	[types.SET_TOKEN](state, token) {
		state.token = token;
	},
	[types.SET_TENANTINFO](state, tenantInfo) {
		state.tenantInfo = tenantInfo;
	},
	[types.SET_ADVANCESEARCHGROUP](state, advanceSearchGroup) {
		state.advanceSearchGroup = advanceSearchGroup;
		// state.advanceSearchGroup = Object.assign(state.advanceSearchGroup, advanceSearchGroup)
	},
	[types.SET_AGREESTATE](state,agreeState){
		state.agreeState=agreeState
	},
	[types.SET_CURRENT_PAPER_INFO](state,currentPaperInfo){
		state.currentPaperInfo=currentPaperInfo
	},
	[types.SET_LANGUAGE](state,language){
		state.language=language
	},
  [types.SET_SYSTEM_INFO](state,systemInfo){
    let authfileType = systemInfo?.authfileType
    let bmfileType = systemInfo?.bmfileType
    let originalStatement = systemInfo?.originalStatement
    // console.log(authfileType)
    if(authfileType){//首次提交字符串转数组，后面更新的时候如果是数组就不需要再分割
      authfileType=authfileType.split(",").filter(item=>item) || ['pdf']
    }
    if(bmfileType){//首次提交字符串转数组，后面更新的时候如果是数组就不需要再分割
      bmfileType=bmfileType.split(",").filter(item=>item) || ['pdf']
    }
    if(originalStatement && JSON.parse(originalStatement)!=='{}'){//originalStatement有配置
      originalStatement=JSON.parse(originalStatement)
    }
    // console.log({...systemInfo,bmfileType,authfileType,originalStatement})
    state.systemInfo={...systemInfo,bmfileType,authfileType,originalStatement}
  },
  [types.CLEARALL](state) {
    let init = {
      userInfo: "", // 用户
      // language: "", // 语种
      token: "",
      tenantInfo: "",
      // systemInfo: "",//系统设置
      advanceSearchGroup: "", // 高级检索
      agreeState:false,//是否同意协议
      currentPaperInfo:null,//当前的论文信息
    }
    for(let key in init) {
      state[key] = init[key]
    }
  }
}
export default mutations;
